import { render, staticRenderFns } from "./requirements.vue?vue&type=template&id=b55c78e0&scoped=true&"
import script from "./requirements.vue?vue&type=script&lang=js&"
export * from "./requirements.vue?vue&type=script&lang=js&"
import style0 from "./requirements.vue?vue&type=style&index=0&id=b55c78e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c78e0",
  null
  
)

export default component.exports